'use client'

import DefaultAlertDialog from '@/components/DefaultAlertDialog'
import { useTranslations } from 'next-intl'

type DeleteCommentConfirmModalProps = {
  open?: boolean
  onCancel?: () => void
  onAction?: () => void
}

export default function DeleteCommentConfirmModal({
  open = false,
  onCancel,
  onAction,
}: DeleteCommentConfirmModalProps) {
  const t = useTranslations()
  return (
    <DefaultAlertDialog
      open={open}
      type="custom"
      title={t('delete-comment-confirm-modal.title')}
      description={t('delete-comment-confirm-modal.description')}
      cancelText={t('delete-comment-confirm-modal.cancel')}
      actionText={t('delete-comment-confirm-modal.action')}
      onCancel={onCancel}
      onAction={onAction}
      cancelButtonClassName="rounded-full px-5 py-3 border-[1.5px] border-vive-primary-20 text-vive-primary-20 buttonM-omni-styles hover:border-vive-primary-40 hover:text-vive-primary-40 active:text-vive-primary-60 active:border-vive-primary-60"
      actionButtonClassName="rounded-full px-5 py-3 text-white buttonM-omni-styles bg-[#f53232] hover:bg-[#d42a2a] active:bg-[#b32424] "
      allowOutsideInteraction={true}
    />
  )
}
